import React, { useEffect, useState } from 'react'
import { Row, Col, Tabs, Card, Button } from 'antd'
import Cards from './components/Cards'
import CardAccountStatement from './components/CardAccountStatement'
import CardStatement from './components/CardStatement'
import AccountStatement from './components/AccountStatement'
import { connect } from 'react-redux'

import "../Transfer/transfer.scss"
import './index.scss'
import { Link, useHistory, useLocation } from "react-router-dom";
import { dateFormatter, getPathnameByIndex } from "../../services/helper";
import GoBack from "components/goBack";
import { checkAnyPermission } from "../../services/permission";
import FullScreenLoading from "components/FullScreenLoading";
import { getOldCards } from "../../services/BrCards/OldCards";
import { getCurrentCompany } from "../../services/user";
import { getNewCards } from "../../services/BrCards/NewCards";
import { ReloadIco2 } from "../../../modules/CustomIcons";
import { useTranslation } from 'react-i18next'
import noSelected from "assets/images/noSelectedTransfer.svg";
import {
  getCardStatementData,
  getCardStatementDataByPan,
  setCardAccountsArray,
  setCardArray,
  setFilterData
} from "store/actions/cardStatement";
import {useActions} from "hooks/useActions";
import { ScreenTitle } from '@app/components/ScreenTitle'
import Tooltip from '@app/components/Tooltip'
import { PlusOutlined } from '@ant-design/icons'
import { useAbility } from '@shared/AccessManager'



const cardStatusInitial = {
  oldCard: 'checking',
  newCard: 'checking'
}

const BusinessCards: React.FC<any> = ({ leftMenuStatus }) => {
  const {t} = useTranslation()
  const [oldBusinessCardsData, setOldBusinessCardData] = useState({});
  const [newBusinessCardsData, setNewBusinessCardData] = useState({});
  const [cardStatus, setCardStatus] = useState(cardStatusInitial);


  const { setCardArray, setCardAccountsArray, getCardStatementData, getCardStatementDataByPan } = useActions();


  const { TabPane } = Tabs;
  const history = useHistory();
  const location = useLocation();


  const [filterDateTime, setFilterDateTime] = useState(dateFormatter());

  const checkCards = async () => {

    const Card_array: React.SetStateAction<any[]> = []
    const CardAccount_array: React.SetStateAction<any[]> = []
    await getOldCards(getCurrentCompany()).then(res => {

      if (res.oldBusinessCards?.MainCards?.length > 0) {
        const response= res.oldBusinessCards.MainCards

        response.map((item)=>{
          Card_array.push({
            label: `${item.nickName !== null ? item.nickName : item.Iban}`,
            value: item.Iban,
            PAN: item.Pan,
            TYPE: "OLD",
            CCY_NAME: item.Currency,
            STATUS: item.CardStat,
            extra: item.Currency
          })
          if (item.Pan !== undefined){

            CardAccount_array.push({
              label: `${item.EncryptedPan}  -  ${item.CardHolder}`,
              value: item.Pan,
              pan:item.Pan,
              IBAN: item.Iban,
              TYPE: "OLD",
              cardHolder:item.CardHolder,
              CCY_NAME: item.Currency,
              STATUS: item.IBANStat,
            })
          }

        })
      }
      setOldBusinessCardData(res);

      setCardStatus(old_data => ({
        ...old_data,
        oldCard: (res.oldBusinessCards?.MainCards?.length > 0) ? 'true' : 'false'
      }))

      if (res.oldBusinessCards?.MainCards?.length > 0) {

        history.push({
          state: { oldBusinessCards: res.oldBusinessCards.MainCards }
        })
      }

    });

    await getNewCards(getCurrentCompany()).then(res => {
      if (res.newBusinessCards?.MainCards?.length > 0) {
        const response= res.newBusinessCards.MainCards
        response.map((item)=>{

          // setLabel(item.nickName !== null ? item.nickName : item.Iban)


            Card_array.push({
              label: `${item.nickName !== null ? item.nickName : item.Iban}`,
              value: item.Iban,
              PAN: item.AdditionCards[item.AdditionCards.length-1]?.Pan,
              TYPE: "NEW",
              CCY_NAME: item.Currency,
              STATUS: item.IBANStat,
              extra: item.Currency

            })
           if(item.AdditionCards?.length>0){
             item.AdditionCards?.map((row)=>{
               CardAccount_array.push({
                 label: `${row.EncryptedPan}  -  ${row?.CardHolder}`,
                 value: row?.Pan,
                 pan: row?.Pan,
                 IBAN: row?.Iban,
                 TYPE: "NEW",
                 cardHolder:row?.CardHolder,
                 CCY_NAME: row.Currency,
                 STATUS: row?.IBANStat,

               })
             })

           }



        })
      }
      setNewBusinessCardData(res);

      setCardStatus(old_data => ({
        ...old_data,
        newCard: (res.newBusinessCards?.MainCards?.length > 0) ? 'true' : 'false'
      }))

    })
    console.log(Card_array)
    setCardArray(Card_array)
    setCardAccountsArray(CardAccount_array)

    setFilterDateTime(old_date => dateFormatter())
  }

  const updateOldCard = (response: any) =>{
    setOldBusinessCardData(response);
  }

  const updateNewCard = (response: any) =>{
    setNewBusinessCardData(response);
  }

  const tabData: Array<any> = [
    {
      index: 1,
      name: t("home.businessCards"),
      content: <Cards oldBusinessCardsData={oldBusinessCardsData} newBusinessCardsData={newBusinessCardsData} cardStatus={cardStatus} updateOldCard={updateOldCard} updateNewCard={updateNewCard}/>,
      path: '/business_cards/cards',
      permissionKeys: ['CARDLIST']
    },
    {
      index: 2,
      name: t("businessCards.cardAccountStatement"),
      content: <AccountStatement />,
      path: '/business_cards/card_account_statement',
      permissionKeys: ['EXTRE_CARD_ACC']
    },
    {
      index: 3,
      name: t("businessCards.cardStatement"),
      content: <CardAccountStatement />,
      path: '/business_cards/card_accountpan_statement',
      permissionKeys: ['EXTRE_CARD_PIN']
    }
  ]

  const find_tab = tabData.find(row => row.path === `/${getPathnameByIndex(0)}/${getPathnameByIndex(1)}`);
  const [tabActiveKey, setTabActiveKey] = useState<number>(find_tab?.index);
  const company = getCurrentCompany().name
  useEffect(() => {
    console.log(company)
    const find_tab = tabData.find(row => row.path === `/${getPathnameByIndex(0)}/${getPathnameByIndex(1)}`);

    setTabActiveKey(find_tab?.index);

    if (getPathnameByIndex(1) && cardStatus.newCard === 'checking' && cardStatus.oldCard === 'checking') {
      checkCards();
    }
  }, [location.pathname])
  useEffect(()=>{
    checkCards();
  },[])
  const tabOnChange = async (activeKey: any) => {
    if (activeKey === "1") {
      setCardStatus(old_data => ({
        ...old_data,
        oldCard: 'checking',
        newCard: 'checking'
      }))
    }
    await refreshData(activeKey);
    setTabActiveKey(old_key => activeKey);
    const find_row = tabData.find(row => row.index == activeKey);
    history.push(find_row.path);
  };

  const reCheckCard = () => {
    setCardStatus(old_data => cardStatusInitial)
    checkCards();
  }

   useEffect(()=>{
    checkCards();
   },[])
  const extraData = (
    <Button icon={<ReloadIco2 />} onClick={reCheckCard} className='transparent box_reload_ico reload_all_business_cards_btn' >
      {filterDateTime}
    </Button>
  )

  const refreshData = async (key) => {
    setFilterDateTime(old_date => dateFormatter());
    if(key === "2" ){
      const formData = {
        startDate: "",
        endDate: "",
        ibanRef: "",
        type: ""
      }
      getCardStatementData({ company: getCurrentCompany(), formData: formData });
    }
    else if(key === "3"){
      const formData = {
        startDate: "",
        endDate: "",
        pan: "",
        // ibanRef: fromBranch.IBAN,
        type: ""
      }
      getCardStatementDataByPan({ company: getCurrentCompany(), formData: formData ,});
    }
  }
  const onClickRight = () => {
    window.location.reload()
  }
  const onClickLeft = () => {
    history.push('/')
  }
    const ability = useAbility()
  
  return (
    <>
      <Row>
        <Col span={24} className="transfer">

          {/* <GoBack title={t("home.businessCards")} extraData={extraData} /> */}
                    <ScreenTitle
            onClickRight={onClickRight}
            onClickLeft={onClickLeft}
            leftValue={t('home.businessCards')}
            rightValue={dateFormatter(new Date())}
            icon={ability.can('view', 'BusinessCardOrderMenuItem') ? <Link to='/orders/business-card/create'>
                <Tooltip title={t('salary.createNewBusinessCard')} placement="right">
                  <PlusOutlined
                    style={{
                      cursor: 'pointer',
                      fontSize: 16,
                      padding: 8,
                      boxSizing: 'border-box',
                      color: '#fff',
                      background: '#015CD1',
                      borderRadius: 30,
                      border: '5px solid #accaf1',
                    }}
                  />
                </Tooltip>
              </Link>: <></>}
          />


          <Tabs
            type="card"
            className={tabActiveKey ? `transfer_parent_tab transfer_parent_tab_${tabActiveKey}` : `table-background transfer_parent_tab_${tabActiveKey}` }
            activeKey={`${tabActiveKey}`}
            onChange={tabOnChange}
            destroyInactiveTabPane={true}
          >


            {tabData &&
              tabData.map((item, index) => {
                // console.log(item.permissionKeys)
                return checkAnyPermission(item.permissionKeys) && (
                  <TabPane
                    className={`transfer_child_tabs`}
                    tab={item.name}
                    key={item.index}
                  >
                    {

                      getPathnameByIndex(1) &&
                      <>
                        {/* {(cardStatus.oldCard === 'true' && cardStatus.newCard === 'true') && item.content} */}

                        {(cardStatus.oldCard === 'true' || cardStatus.newCard === 'true') && item.content}

                        {(cardStatus.oldCard === 'false' && cardStatus.newCard === 'false') && <div className={'full flex justify_center table_no_data flex_wrap'}><h3>{t("businessCards.noBusinessCard")}</h3></div>}

                        {(cardStatus.oldCard === 'checking' || cardStatus.newCard === 'checking') && <FullScreenLoading />}
                      </>
                    }
                  </TabPane>
                )
              })}
          </Tabs>
        </Col>
        { tabActiveKey === undefined && <span className={'noSelected'}>{t("newTransfer.noSelectedTransfer")}
          <img src={noSelected}/>
              </span> }
      </Row>
    </>
  )
}

const mapDispatchToProps = { setCardArray, getCardStatementData, getCardStatementDataByPan }
const mapStateToProps = (state: any) => ({
  leftMenuStatus: state.home.leftMenuStatus,
})
export default connect(mapStateToProps, mapDispatchToProps)(BusinessCards)
